import sha1 from "js-sha1";
import { ImpactPayLoad } from "../../../types/ImpactTracking";

// Define a type for the window object
interface ImpactWindow extends Window {
  ire?: (eventName: string, ...args: any[]) => void;
  dataLayer?: { event: string }[];
}

export const sendConversionToImpact = (data: ImpactPayLoad) => {
  const subTotal = data.plan === "ANNUAL" ? 23 : 4.2;
  const name = data.plan === "ANNUAL" ? "Yearly Membership" : "Monthly Membership";
  const sku = data.plan === "ANNUAL" ? "yearly" : "monthly";
  const currency = "USD";

  if (typeof window !== "undefined") {
    const impactWindow = window as ImpactWindow;

    if (typeof impactWindow.ire !== "undefined") {
      impactWindow.ire(
        "trackConversion",
        38241,
        {
          orderId: data.id,
          customerId: data.userId,
          customerEmail: sha1(data.email),
          customerStatus: data.customerStatus,
          currencyCode: currency,
          orderPromoCode: "",
          orderDiscount: 0,
          items: [
            {
              subTotal: subTotal,
              category: "Subscription Plan",
              sku: sku,
              quantity: 1,
              name: name,
            },
          ],
        },
        { verifySiteDefinitionMatch: true }
      );
    }
  }
};

export const isUttLoaded = (): boolean => {
  // Check if window is defined (client-side)
  if (typeof window !== "undefined") {
    const customWindow = window as ImpactWindow;

    // Check if dataLayer is defined and has the desired event
    return !!customWindow.dataLayer?.some((item: { event: string }) => item.event === "UttLoaded");
  }

  // Return false for server-side rendering
  return false;
};
